// NOTE this is type of messages that come from the websockets
// onmessage (msg) => msg.data.type

export const WEBSOCKET_MESSAGING_EVENT_TYPES = {
  ENTER_CHAT: "enter_chat",
  CHAT: "chat", //message type for sending a chat message
} as const;
